// extracted by mini-css-extract-plugin
export var createdDate = "_h7-1";
export var divider = "_h7-2";
export var headerDivider = "_h7-3";
export var messagesCard = "_h7-0";
export var messagesContainer = "_h7-6";
export var messagesContainerWrapper = "_h7-4";
export var showLeftPanelButton = "_h7-8";
export var topButtons = "_h7-7";
export var withPadding = "_h7-5";